<template>
    <div>
        <!-- Блок статистики заявок на вывод средств -->
        <AgentWithdrawalRequestStatistics />
        
        <AgentWithdrawalRequestFinderAndCreator
            :key="componentRefreshKey"
            :isNeedCreate="true"
            :changed-item="changedItem"
            :additionalGetParameter="additionalGetParameter"
            :typeOfTableFilter="$route.params.status ? '' : ''"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AgentWithdrawalRequestFinderAndCreator from '@/components/agentWithdrawalRequests/AgentWithdrawalRequestFinderAndCreator.vue'
    import AgentWithdrawalRequestStatistics from '@/components/agentWithdrawalRequests/AgentWithdrawalRequestStatistics.vue'

    export default {
        components: {
            AgentWithdrawalRequestFinderAndCreator,
            AgentWithdrawalRequestStatistics,
        },
        props: {
            changedItem: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                additionalGetParameter: '',
                componentRefreshKey: 0,
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),
        },
        created() {
            this.additionalGetParameterChanger()
        },
        watch: {
            '$route.path'() {
                this.additionalGetParameterChanger()
            }
        },
        methods: {
            additionalGetParameterChanger() {
                if (this.$route.params.status) {
                    this.additionalGetParameter = `&status=${this.$route.params.status}`
                } else {
                    this.additionalGetParameter = ''
                }
                this.componentRefreshKey += 1
            },
        }
    }
</script>

